import {
	Box,
	Button,
	FormControl,
	InputLabel,
	Modal,
	NativeSelect,
	TextField,
	useMediaQuery,
} from "@mui/material"
import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import * as yup from "yup"
import Header from "../../components/Header"
import ProjectModuleApi from "../../services/api/ProjectModules"

function ProjectModuleForm({
	formData,
	projects,
	moduleCategories,
	open,
	handleClose,
}) {
	const isNonMobile = useMediaQuery("(min-width:600px)")
	const [isEdit, setIsEdit] = useState(false)

	const modalStyle = {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	}

	const preventCloseBackdrop = (props) => (
		<div {...props} style={{ pointerEvents: "none" }} />
	)

	const formik = useFormik({
		initialValues: initialValues,
		validationSchema: checkoutSchema,

		onSubmit: async (values, { resetForm }) => {
			console.log(values)
			if (isEdit) {
				editEntity(values)
			} else {
				createEntity(values)
			}

			resetForm()
		},
	})

	useEffect(() => {
		if (formData) {
			formik.setValues({
				...formData,
			})

			setIsEdit(true)
		} else {
			formik.setValues({
				...initialValues,
			})
			setIsEdit(false)
		}
	}, [formData])

	const createEntity = async (values) => {
		const response = await ProjectModuleApi().create(values)

		console.log(createdSuccessMsg, response)
		handleClose()
	}

	const editEntity = async (values) => {
		const response = await ProjectModuleApi().edit(formData.id, values)

		console.log(updatedSuccessMsg, response)
		handleClose()
	}

	const modalBody = (
		<Box
			sx={{
				width: "60%",
				bgcolor: "background.paper",
				boxShadow: 24,
				p: 2,
			}}
		>
			<Header title={`${formName} Detail`} subtitle="" />

			<form onSubmit={formik.handleSubmit}>
				<Box
					display="grid"
					gap="30px"
					gridTemplateColumns="repeat(4, minmax(0, 1fr))"
					sx={{
						"& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
					}}
				>
					<FormControl fullWidth sx={{ gridColumn: "span 4" }}>
						<InputLabel variant="standard" htmlFor="uncontrolled-native">
							Project
						</InputLabel>
						<NativeSelect
							value={formik.values.project_id}
							onChange={formik.handleChange}
							inputProps={{
								name: "project_id",
							}}
						>
							{projects.map((row) => (
								<option value={row.id}>{row.name}</option>
							))}
						</NativeSelect>
					</FormControl>

					<FormControl fullWidth sx={{ gridColumn: "span 4" }}>
						<InputLabel variant="standard" htmlFor="uncontrolled-native">
							Category
						</InputLabel>
						<NativeSelect
							value={formik.values.category_id}
							onChange={formik.handleChange}
							inputProps={{
								name: "category_id",
							}}
						>
							{moduleCategories.map((row) => (
								<option value={row.id}>{row.name}</option>
							))}
						</NativeSelect>
					</FormControl>

					<TextField
						fullWidth
						variant="filled"
						type="text"
						label="Name"
						autoComplete="off"
						onBlur={formik.handleBlur}
						onChange={formik.handleChange}
						name="name"
						value={formik.values.name}
						inputProps={{ maxLength: 50 }}
						error={!!formik.touched.name && !!formik.errors.name}
						helperText={formik.touched.name && formik.errors.name}
						sx={{ gridColumn: "span 4" }}
					/>
					<TextField
						fullWidth
						variant="filled"
						type="text"
						label="path"
						autoComplete="off"
						onBlur={formik.handleBlur}
						onChange={formik.handleChange}
						name="path"
						value={formik.values.path}
						inputProps={{ maxLength: 50 }}
						error={!!formik.touched.path && !!formik.errors.path}
						helperText={formik.touched.path && formik.errors.path}
						sx={{ gridColumn: "span 4" }}
					/>

					<TextField
						fullWidth
						variant="filled"
						type="text"
						label="Order No"
						autoComplete="off"
						onBlur={formik.handleBlur}
						onChange={formik.handleChange}
						name="order_no"
						value={formik.values.order_no}
						inputProps={{ maxLength: 10 }}
						error={!!formik.touched.order_no && !!formik.errors.order_no}
						helperText={formik.touched.order_no && formik.errors.order_no}
						sx={{ gridColumn: "span 1" }}
					/>

					<TextField
						fullWidth
						variant="filled"
						type="text"
						label="Icon"
						autoComplete="off"
						onBlur={formik.handleBlur}
						onChange={formik.handleChange}
						name="icon"
						value={formik.values.icon}
						inputProps={{ maxLength: 50 }}
						error={!!formik.touched.icon && !!formik.errors.icon}
						helperText={formik.touched.icon && formik.errors.icon}
						sx={{ gridColumn: "span 1" }}
					/>

				</Box>
				<Box display="flex" justifyContent="space-between" mt="20px">
					<Button variant="contained" onClick={handleClose}>
						Close
					</Button>
					<Button type="submit" color="secondary" variant="contained">
						{isEdit ? `Update ${formName}` : `Create New ${formName}`}
					</Button>
				</Box>
			</form>
		</Box>
	)

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
			style={modalStyle}
			BackdropComponent={preventCloseBackdrop}
		>
			{modalBody}
		</Modal>
	)
}

const checkoutSchema = yup.object().shape({
	project_id: yup.number().required("required"),
	category_id: yup.number().required("required"),
	name: yup
		.string()
		.required("required")
		.max(100, "Maximum characters limit exceeds"),
	path: yup
		.string()
		.required("required")
		.max(100, "Maximum characters limit exceeds"),
	order_no: yup.number().required("required"),
})

const initialValues = {
	project_id: " ",
	category_id: " ",
	name: "",
	path: "",
	order_no: "",
	icon: "RadioButtonCheckedIcon",
}

const formName = "Project Module"
const createdSuccessMsg = `${formName} created:`
const updatedSuccessMsg = `${formName} updated:`

export default ProjectModuleForm
